/**
 * Created by stonewang on 2017/8/15.
 */
import {config, request} from 'Utils';

//库存列表
export function list(param) {
  return request(`${config.server}/api/v1/dms/storageInventory/list`, {
    method: 'post',
    body: param,
  });
}
//新建库存
export function add(param) {
  return request(`${config.server}/api/v1/dms/storageInventory/save`, {
    method: 'post',
    body: param,
  });
}
//库存调整
export function update(param) {
  return request(`${config.server}/api/v1/dms/storageInventory/update`, {
    method: 'post',
    body: param,
  });
}

export const exportFun = `${config.server}/api/v1/dms/storageInventory/exportInventory`;



// WEBPACK FOOTER //
// ./src/service/inventory/inventory.js